var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 74,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    x: 0.5,
    fill: "#FDE6F4",
    rx: 37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EC008C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.612,
    d: "m16.746 27.777 6.276 5.23c.415.345.937.534 1.477.534h26c.54 0 1.062-.189 1.477-.534l6.276-5.23M24.817 41.612h.023m25.341 0h.023M28.646 19.706h17.706c1.655 0 3.183.887 4.004 2.324l6.68 11.69a9.2 9.2 0 0 1 1.216 4.577v13.691a2.306 2.306 0 0 1-2.306 2.306H53.64a2.306 2.306 0 0 1-2.306-2.306v-2.306h-27.67v2.306a2.306 2.306 0 0 1-2.306 2.306h-2.306a2.306 2.306 0 0 1-2.306-2.306V38.297c0-1.606.419-3.183 1.215-4.576l6.68-11.691a4.61 4.61 0 0 1 4.005-2.324M25.97 41.612a1.153 1.153 0 1 1-2.306 0 1.153 1.153 0 0 1 2.306 0m25.364 0a1.153 1.153 0 1 1-2.306 0 1.153 1.153 0 0 1 2.306 0"
  })));
};
export default SvgCar;